import {
  faArrowRightArrowLeft,
  faArrowsRotate,
  faBrain,
  faBuilding,
  faCalendarCheck,
  faCircleExclamation,
  faClipboardCheck,
  faDollarSign,
  faEnvelopeBadge,
  faEnvelopeCircleCheck,
  faEnvelopesBulk,
  faFileSlash,
  faGlobe,
  faHandHoldingMedical,
  faHandWave,
  faHeadSideGear,
  faHeartPulse,
  faHospital,
  faIdCard,
  faLanguage,
  faPeopleArrows,
  faPersonCane,
  faPhone,
  faPhoneArrowDownLeft,
  faPhoneArrowUpRight,
  faPhoneMissed,
  faPhoneSlash,
  faPhoneVolume,
  faPhoneXmark,
  faPrescriptionBottle,
  faRecycle,
  faRobot,
  faShieldCheck,
  faSkull,
  faStethoscope,
  faThumbsDown,
  faThumbsUp,
  faTrash,
  faTriangleExclamation,
  faUser,
  faUserCheck,
  faUserClock,
  faUserGear,
  faUserGroup,
  faUserHeadset,
  faUserLock,
  faUserMinus,
  faUserShield,
  faUserSlash,
  faUserXmark,
  faVolumeMute,
  faVrCardboard,
} from '@fortawesome/pro-regular-svg-icons';
import {
  Consumer_Dialer_Result,
  Consumer_Dialer_ResultCategory,
  consumer_Dialer_ResultCategoryToJSON,
  consumer_Dialer_ResultToJSON,
} from '@enrollhere/classes';
import { IconListItemA } from '../../classes/IconListItem';

export const DISPO_LIST_SALE = [
  Consumer_Dialer_Result.S_APP_SUBMITTED,
  Consumer_Dialer_Result.S_APP_SUBMITTED_P_ANCILLARY,
  Consumer_Dialer_Result.S_APP_SUBMITTED_P_MS,
  Consumer_Dialer_Result.S_APP_SUBMITTED_DOUBLE_SALE,
  Consumer_Dialer_Result.S_APP_SUBMITTED_DOUBLE_SALE_ANCILLARY,
  Consumer_Dialer_Result.S_APP_SUBMITTED_DOUBLE_SALE_ANCILLARY_DOUBLE,
  Consumer_Dialer_Result.S_APP_SUBMITTED_TRIPLE_SALE,
];

export const DISPO_LIST_TRANSFER_TO_AGENT = [
  Consumer_Dialer_Result.S_AGENT_TO_AGENT,
];

export const DISPO_LIST_DOUBLE_SALE = [
  Consumer_Dialer_Result.S_APP_SUBMITTED_DOUBLE_SALE,
  Consumer_Dialer_Result.S_APP_SUBMITTED_DOUBLE_SALE_ANCILLARY,
  Consumer_Dialer_Result.S_APP_SUBMITTED_DOUBLE_SALE_ANCILLARY_DOUBLE,
];

export const DISPO_LIST_TRIPLE_SALE = [
  Consumer_Dialer_Result.S_APP_SUBMITTED_TRIPLE_SALE,
];

export const consumerResultMap: { [key: number]: Partial<IconListItemA> } = {
  [Consumer_Dialer_Result.S_AGENT_TO_AGENT]: {
    icon: faPeopleArrows,
    // title: 'Agent to Agent Transfer',
    title: 'Transfer To Agent',
    color: 'green',
  },
  [Consumer_Dialer_Result.S_APP_SUBMITTED]: {
    icon: faEnvelopeCircleCheck,
    title: 'Application Submitted',
    color: 'green',
  },
  [Consumer_Dialer_Result.S_APP_SUBMITTED_DOUBLE_SALE]: {
    icon: faEnvelopesBulk,
    title: 'Application Submitted Double Sale',
    color: 'green',
  },
  [Consumer_Dialer_Result.S_APP_SUBMITTED_P_ANCILLARY]: {
    icon: faEnvelopeBadge,
    title: 'App Submitted + Ancillary',
    color: 'green',
  },
  [Consumer_Dialer_Result.S_APP_ANCILLARY]: {
    icon: faHeadSideGear,
    title: 'Ancillary Sale',
    color: 'green',
  },
  [Consumer_Dialer_Result.S_APP_SUBMITTED_P_MS]: {
    icon: faUserGear,
    title: 'App Submitted + MedSupp',
    color: 'green',
  },
  [Consumer_Dialer_Result.S_APP_MS]: {
    icon: faPersonCane,
    title: 'MedSupp Sale',
    color: 'green',
  },
  [Consumer_Dialer_Result.S_EXISTING_CLIENT_CALLBACK]: {
    icon: faPhoneArrowDownLeft,
    title: 'Existing Client Callback',
    color: 'green',
  },
  [Consumer_Dialer_Result.S_APPOINTMENT_BOOKED]: {
    icon: faCalendarCheck,
    title: 'Appointment Booked',
    color: 'green',
  },
  [Consumer_Dialer_Result.S_APP_LIFE]: {
    icon: faHeartPulse,
    title: 'Life Sale',
    color: 'green',
    category: Consumer_Dialer_ResultCategory.SUCCESS,
  },
  [Consumer_Dialer_Result.S_APP_PDP]: {
    icon: faPrescriptionBottle,
    title: 'PDP Sale',
    color: 'green',
    category: Consumer_Dialer_ResultCategory.SUCCESS,
  },
  [Consumer_Dialer_Result.S_APP_HIP]: {
    icon: faHospital,
    title: 'HIP Sale',
    color: 'green',
    category: Consumer_Dialer_ResultCategory.SUCCESS,
  },
  [Consumer_Dialer_Result.S_APP_MAPD]: {
    icon: faStethoscope,
    title: 'MAPD Sale',
    color: 'green',
    category: Consumer_Dialer_ResultCategory.SUCCESS,
  },
  [Consumer_Dialer_Result.S_APP_ANCILLARY_DOUBLE]: {
    icon: faHeadSideGear,
    title: 'Ancillary Double Sale',
    color: 'green',
    category: Consumer_Dialer_ResultCategory.SUCCESS,
  },
  [Consumer_Dialer_Result.S_APP_FE_DOUBLE_ANCILLARY]: {
    icon: faHeadSideGear,
    title: 'FE Double Ancillary Sale',
    color: 'green',
    category: Consumer_Dialer_ResultCategory.SUCCESS,
  },
  [Consumer_Dialer_Result.S_APP_FE_DOUBLE]: {
    icon: faEnvelopesBulk,
    title: 'FE Double Sale',
    color: 'green',
    category: Consumer_Dialer_ResultCategory.SUCCESS,
  },
  [Consumer_Dialer_Result.S_APP_SUBMITTED_DOUBLE_SALE_ANCILLARY]: {
    icon: faEnvelopeBadge,
    title: 'MA Double Sale + Ancillary',
    color: 'green',
    category: Consumer_Dialer_ResultCategory.SUCCESS,
  },
  [Consumer_Dialer_Result.S_APP_SUBMITTED_DOUBLE_SALE_ANCILLARY_DOUBLE]: {
    icon: faEnvelopesBulk,
    title: 'MA Double Sale + Ancillary Double Sale',
    color: 'green',
    category: Consumer_Dialer_ResultCategory.SUCCESS,
  },
  [Consumer_Dialer_Result.S_APP_SUBMITTED_TRIPLE_SALE]: {
    icon: faEnvelopesBulk,
    title: 'MA Triple Sale',
    color: 'green',
    category: Consumer_Dialer_ResultCategory.SUCCESS,
  },
  [Consumer_Dialer_Result.S_ENROLLER_SUCCESS]: {
    icon: faUserCheck,
    title: 'Enroller Success',
    color: 'green',
    category: Consumer_Dialer_ResultCategory.SUCCESS,
  },
  [Consumer_Dialer_Result.S_WELCOME_CALL_SUCCESS]: {
    icon: faHandWave,
    title: 'Welcome Call Success',
    color: 'green',
    category: Consumer_Dialer_ResultCategory.SUCCESS,
  },
  [Consumer_Dialer_Result.S_RETENTION_SAVED]: {
    icon: faUserShield,
    title: 'Retention Saved',
    color: 'green',
    category: Consumer_Dialer_ResultCategory.SUCCESS,
  },
  [Consumer_Dialer_Result.S_FRONTER_SUCCESS]: {
    icon: faUserHeadset,
    title: 'Fronter Success',
    color: 'green',
    category: Consumer_Dialer_ResultCategory.SUCCESS,
  },

  [Consumer_Dialer_Result.R_CALL_BACK]: {
    icon: faPhoneArrowUpRight,
    title: 'Call Back',
    color: 'yellow',
  },
  [Consumer_Dialer_Result.R_ANSWERING_MACHINE]: {
    icon: faRobot,
    title: 'Answering Machine',
    color: 'yellow',
  },
  [Consumer_Dialer_Result.R_DROPPED_CALL]: {
    icon: faPhoneMissed,
    title: 'Dropped Call',
    color: 'red',
  },
  [Consumer_Dialer_Result.R_PRE_AEP_APPOINTMENT]: {
    icon: faCalendarCheck,
    title: 'Pre AEP Appointment',
    color: 'yellow',
  },
  [Consumer_Dialer_Result.R_NOT_AVAILABLE]: {
    icon: faPhoneXmark,
    title: 'Not Available',
    color: 'yellow',
  },
  [Consumer_Dialer_Result.R_NO_SEP]: {
    icon: faCalendarCheck,
    title: 'No SEP',
    color: 'yellow',
  },
  [Consumer_Dialer_Result.R_NOT_LICENSED_STATE]: {
    icon: faGlobe,
    title: 'Not Licensed in State',
    color: 'yellow',
  },
  [Consumer_Dialer_Result.R_CLIENT_HANGUP]: {
    icon: faPhoneSlash,
    title: 'Client Hangup',
    color: 'yellow',
  },
  [Consumer_Dialer_Result.R_CLIENT_HANGUP_DURING_TRANSFER]: {
    icon: faPhoneSlash,
    title: 'Client Hangup During Transfer',
    color: 'yellow',
  },
  [Consumer_Dialer_Result.R_CLIENT_UNWILLING_SWITCH]: {
    icon: faUserLock,
    title: 'Client Unwilling to Switch',
    color: 'yellow',
  },
  [Consumer_Dialer_Result.R_MISSED_OPPORTUNITY]: {
    icon: faUserSlash,
    title: 'Missed Opportunity',
    color: 'yellow',
  },
  [Consumer_Dialer_Result.R_NON_QUALIFIED_TRANSFER]: {
    icon: faUserSlash,
    title: 'Non Qualified Transfer',
    color: 'yellow',
  },
  [Consumer_Dialer_Result.R_NO_TRANSFER_AGENT_AVAILABLE]: {
    icon: faUserClock,
    title: 'No Transfer Agent Available',
    color: 'yellow',
  },
  [Consumer_Dialer_Result.R_ON_BEST_PLAN]: {
    icon: faThumbsUp,
    title: 'On Best Plan',
    color: 'yellow',
  },
  [Consumer_Dialer_Result.R_DOES_NOT_MAKE_HEALTHCARE_DECISIONS]: {
    icon: faUserGear,
    title: 'Does Not Make Healthcare Decisions',
    color: 'yellow',
  },
  [Consumer_Dialer_Result.R_UHC_CALLBACK]: {
    icon: faPhone,
    title: 'UHC Callback',
    color: 'yellow',
  },
  [Consumer_Dialer_Result.R_HOME_OFFICE_VISIT]: {
    icon: faBuilding,
    title: 'Home Office Visit',
    color: 'yellow',
    category: Consumer_Dialer_ResultCategory.RECYCLE,
  },
  [Consumer_Dialer_Result.R_INTERNAL_TRANSFER]: {
    icon: faUserGroup,
    title: 'Internal Transfer',
    color: 'yellow',
    category: Consumer_Dialer_ResultCategory.RECYCLE,
  },
  [Consumer_Dialer_Result.R_AGENT_TEST_CALL]: {
    icon: faVrCardboard,
    title: 'Agent Test Call',
    color: 'yellow',
    category: Consumer_Dialer_ResultCategory.RECYCLE,
  },
  [Consumer_Dialer_Result.R_AGENT_HANGUP]: {
    icon: faPhoneSlash,
    title: 'Agent Hangup',
    color: 'yellow',
    category: Consumer_Dialer_ResultCategory.RECYCLE,
  },
  [Consumer_Dialer_Result.R_NOT_INTERESTED]: {
    icon: faUserMinus,
    title: 'Not Interested',
    color: 'yellow',
    category: Consumer_Dialer_ResultCategory.RECYCLE,
  },
  [Consumer_Dialer_Result.R_NO_MEDICARE_CARD_SSN]: {
    icon: faIdCard,
    title: 'No Medicare Card or SSN',
    color: 'yellow',
    category: Consumer_Dialer_ResultCategory.RECYCLE,
  },
  [Consumer_Dialer_Result.R_TRANSFERRED]: {
    icon: faArrowRightArrowLeft,
    title: 'Transferred',
    color: 'yellow',
    category: Consumer_Dialer_ResultCategory.RECYCLE,
  },
  [Consumer_Dialer_Result.R_CALL_QUALITY]: {
    icon: faPhoneVolume,
    title: 'Call Quality',
    color: 'yellow',
    category: Consumer_Dialer_ResultCategory.RECYCLE,
  },
  [Consumer_Dialer_Result.R_LIS_PENDING]: {
    icon: faDollarSign,
    title: 'LIS Pending',
    color: 'yellow',
    category: Consumer_Dialer_ResultCategory.RECYCLE,
  },
  [Consumer_Dialer_Result.R_MEDICAID_PENDING]: {
    icon: faHandHoldingMedical,
    title: 'Medicaid Pending',
    color: 'yellow',
    category: Consumer_Dialer_ResultCategory.RECYCLE,
  },
  [Consumer_Dialer_Result.R_MEDICARE_QUALIFICATIONS]: {
    icon: faClipboardCheck,
    title: 'Medicare Qualifications',
    color: 'yellow',
    category: Consumer_Dialer_ResultCategory.RECYCLE,
  },
  [Consumer_Dialer_Result.R_NO_MEDICARE]: {
    icon: faIdCard,
    title: 'No Medicare',
    color: 'yellow',
    category: Consumer_Dialer_ResultCategory.RECYCLE,
  },
  [Consumer_Dialer_Result.R_NOT_DECISION_MAKER]: {
    icon: faUserGear,
    title: 'Not Decision Maker',
    color: 'yellow',
    category: Consumer_Dialer_ResultCategory.RECYCLE,
  },
  [Consumer_Dialer_Result.R_NOT_MENTALLY_CAPABLE]: {
    icon: faBrain,
    title: 'Not Mentally Capable',
    color: 'yellow',
    category: Consumer_Dialer_ResultCategory.RECYCLE,
  },
  [Consumer_Dialer_Result.R_SUSPICIOUS_AD]: {
    icon: faTriangleExclamation,
    title: 'Suspicious AD',
    color: 'yellow',
    category: Consumer_Dialer_ResultCategory.RECYCLE,
  },
  [Consumer_Dialer_Result.R_SYSTEM_ACCESS]: {
    icon: faShieldCheck,
    title: 'System Access',
    color: 'yellow',
    category: Consumer_Dialer_ResultCategory.RECYCLE,
  },
  [Consumer_Dialer_Result.R_UNCLEAR_DISCONNECT]: {
    icon: faCircleExclamation,
    title: 'Unclear Disconnect',
    color: 'yellow',
    category: Consumer_Dialer_ResultCategory.RECYCLE,
  },
  [Consumer_Dialer_Result.R_ENROLLER_FAILURE]: {
    icon: faUserXmark,
    title: 'Enroller Failure',
    color: 'yellow',
    category: Consumer_Dialer_ResultCategory.RECYCLE,
  },
  [Consumer_Dialer_Result.R_MEMBER_SERVICES_TRANSFER]: {
    icon: faUserGroup,
    title: 'Member Services Transfer',
    color: 'yellow',
    category: Consumer_Dialer_ResultCategory.RECYCLE,
  },
  [Consumer_Dialer_Result.R_BROKER_TRANSFER]: {
    icon: faPeopleArrows,
    title: 'Broker Transfer',
    color: 'yellow',
    category: Consumer_Dialer_ResultCategory.RECYCLE,
  },
  [Consumer_Dialer_Result.R_NON_CONSUMER_CALL]: {
    icon: faPhone,
    title: 'Non-Consumer Call',
    color: 'yellow',
    category: Consumer_Dialer_ResultCategory.RECYCLE,
  },
  [Consumer_Dialer_Result.T_CLIENT_NO_A_B]: {
    icon: faUserXmark,
    title: "Client doesn't have A/B",
    color: 'red',
  },
  [Consumer_Dialer_Result.T_CLIENT_REFUSES_GIVE_INFO]: {
    icon: faFileSlash,
    title: 'Client refuses to give info',
    color: 'red',
  },
  [Consumer_Dialer_Result.T_DO_NOT_CALL]: {
    icon: faUserLock,
    title: 'Do Not Call',
    color: 'red',
  },
  [Consumer_Dialer_Result.T_LANGUAGE_BARRIER]: {
    icon: faLanguage,
    title: 'Language Barrier',
    color: 'red',
  },
  [Consumer_Dialer_Result.T_MEDICARE_SUPPLEMENT_PLAN]: {
    icon: faHeadSideGear,
    title: 'Medicare Supplement Plan',
    color: 'red',
  },
  [Consumer_Dialer_Result.T_RETIREMENT_PLAN]: {
    icon: faPersonCane,
    title: 'Retirement Plan',
    color: 'red',
  },
  [Consumer_Dialer_Result.T_EXISTING_CLIENT]: {
    icon: faUser,
    title: 'Existing Client',
    color: 'red',
  },
  [Consumer_Dialer_Result.T_NOT_INTERESTED]: {
    icon: faUserSlash,
    title: 'Not Interested',
    color: 'red',
  },
  [Consumer_Dialer_Result.T_UNDER_65]: {
    icon: faUserXmark,
    title: 'Under 65',
    color: 'red',
  },
  [Consumer_Dialer_Result.T_WRONG_NUMBER]: {
    icon: faPhoneSlash,
    title: 'Wrong Number',
    color: 'red',
  },
  [Consumer_Dialer_Result.T_DEAD_AIR]: {
    icon: faVolumeMute,
    title: 'Dead Air',
    color: 'red',
  },
  [Consumer_Dialer_Result.T_DECEASED]: {
    icon: faSkull,
    title: 'Deceased',
    color: 'red',
  },
  [Consumer_Dialer_Result.T_PLAN_HOPPER]: {
    icon: faArrowsRotate,
    title: 'Plan Hopper',
    color: 'red',
  },
  [Consumer_Dialer_Result.T_POA_DEMENTIA]: {
    icon: faBrain,
    title: 'POA Dementia',
    color: 'red',
  },
  [Consumer_Dialer_Result.T_IN_NURSING_HOME]: {
    icon: faHospital,
    title: 'In Nursing Home',
    color: 'red',
  },
  [Consumer_Dialer_Result.T_CLIENT_NOT_SATISFIED]: {
    icon: faThumbsDown,
    title: 'Client Not Satisfied',
    color: 'red',
  },
};

export const consumerResultList = [
  {
    id: Consumer_Dialer_Result.S_AGENT_TO_AGENT,
    ...consumerResultMap[Consumer_Dialer_Result.S_AGENT_TO_AGENT],
  },
  {
    id: Consumer_Dialer_Result.S_APP_SUBMITTED,
    ...consumerResultMap[Consumer_Dialer_Result.S_APP_SUBMITTED],
  },
  {
    id: Consumer_Dialer_Result.S_APP_SUBMITTED_DOUBLE_SALE,
    ...consumerResultMap[Consumer_Dialer_Result.S_APP_SUBMITTED_DOUBLE_SALE],
  },
  {
    id: Consumer_Dialer_Result.S_APP_SUBMITTED_P_ANCILLARY,
    ...consumerResultMap[Consumer_Dialer_Result.S_APP_SUBMITTED_P_ANCILLARY],
  },
  {
    id: Consumer_Dialer_Result.S_APP_SUBMITTED_P_MS,
    ...consumerResultMap[Consumer_Dialer_Result.S_APP_SUBMITTED_P_MS],
  },
  {
    id: Consumer_Dialer_Result.S_APP_ANCILLARY,
    ...consumerResultMap[Consumer_Dialer_Result.S_APP_ANCILLARY],
  },
  {
    id: Consumer_Dialer_Result.S_APP_MS,
    ...consumerResultMap[Consumer_Dialer_Result.S_APP_MS],
  },
  {
    id: Consumer_Dialer_Result.S_APP_LIFE,
    ...consumerResultMap[Consumer_Dialer_Result.S_APP_LIFE],
  },
  {
    id: Consumer_Dialer_Result.S_APP_PDP,
    ...consumerResultMap[Consumer_Dialer_Result.S_APP_PDP],
  },
  {
    id: Consumer_Dialer_Result.S_APP_HIP,
    ...consumerResultMap[Consumer_Dialer_Result.S_APP_HIP],
  },
  {
    id: Consumer_Dialer_Result.S_APP_MAPD,
    ...consumerResultMap[Consumer_Dialer_Result.S_APP_MAPD],
  },
  {
    id: Consumer_Dialer_Result.S_EXISTING_CLIENT_CALLBACK,
    ...consumerResultMap[Consumer_Dialer_Result.S_EXISTING_CLIENT_CALLBACK],
  },
  {
    id: Consumer_Dialer_Result.S_APPOINTMENT_BOOKED,
    ...consumerResultMap[Consumer_Dialer_Result.S_APPOINTMENT_BOOKED],
  },
  {
    id: Consumer_Dialer_Result.S_ENROLLER_SUCCESS,
    ...consumerResultMap[Consumer_Dialer_Result.S_ENROLLER_SUCCESS],
  },
  {
    id: Consumer_Dialer_Result.S_WELCOME_CALL_SUCCESS,
    ...consumerResultMap[Consumer_Dialer_Result.S_WELCOME_CALL_SUCCESS],
  },
  {
    id: Consumer_Dialer_Result.S_RETENTION_SAVED,
    ...consumerResultMap[Consumer_Dialer_Result.S_RETENTION_SAVED],
  },
  {
    id: Consumer_Dialer_Result.S_FRONTER_SUCCESS,
    ...consumerResultMap[Consumer_Dialer_Result.S_FRONTER_SUCCESS],
  },
  {
    id: Consumer_Dialer_Result.S_APP_ANCILLARY_DOUBLE,
    ...consumerResultMap[Consumer_Dialer_Result.S_APP_ANCILLARY_DOUBLE],
  },
  {
    id: Consumer_Dialer_Result.S_APP_FE_DOUBLE_ANCILLARY,
    ...consumerResultMap[Consumer_Dialer_Result.S_APP_FE_DOUBLE_ANCILLARY],
  },
  {
    id: Consumer_Dialer_Result.S_APP_FE_DOUBLE,
    ...consumerResultMap[Consumer_Dialer_Result.S_APP_FE_DOUBLE],
  },
  {
    id: Consumer_Dialer_Result.S_APP_SUBMITTED_DOUBLE_SALE_ANCILLARY,
    ...consumerResultMap[
      Consumer_Dialer_Result.S_APP_SUBMITTED_DOUBLE_SALE_ANCILLARY
    ],
  },
  {
    id: Consumer_Dialer_Result.S_APP_SUBMITTED_DOUBLE_SALE_ANCILLARY_DOUBLE,
    ...consumerResultMap[
      Consumer_Dialer_Result.S_APP_SUBMITTED_DOUBLE_SALE_ANCILLARY_DOUBLE
    ],
  },
  {
    id: Consumer_Dialer_Result.S_APP_SUBMITTED_TRIPLE_SALE,
    ...consumerResultMap[Consumer_Dialer_Result.S_APP_SUBMITTED_TRIPLE_SALE],
  },
  {
    id: Consumer_Dialer_Result.R_CALL_BACK,
    ...consumerResultMap[Consumer_Dialer_Result.R_CALL_BACK],
  },
  {
    id: Consumer_Dialer_Result.R_CLIENT_HANGUP,
    ...consumerResultMap[Consumer_Dialer_Result.R_CLIENT_HANGUP],
  },
  {
    id: Consumer_Dialer_Result.R_CLIENT_HANGUP_DURING_TRANSFER,
    ...consumerResultMap[
      Consumer_Dialer_Result.R_CLIENT_HANGUP_DURING_TRANSFER
    ],
  },
  {
    id: Consumer_Dialer_Result.R_CLIENT_UNWILLING_SWITCH,
    ...consumerResultMap[Consumer_Dialer_Result.R_CLIENT_UNWILLING_SWITCH],
  },
  {
    id: Consumer_Dialer_Result.R_MISSED_OPPORTUNITY,
    ...consumerResultMap[Consumer_Dialer_Result.R_MISSED_OPPORTUNITY],
  },
  {
    id: Consumer_Dialer_Result.R_NON_QUALIFIED_TRANSFER,
    ...consumerResultMap[Consumer_Dialer_Result.R_NON_QUALIFIED_TRANSFER],
  },
  {
    id: Consumer_Dialer_Result.R_NO_TRANSFER_AGENT_AVAILABLE,
    ...consumerResultMap[Consumer_Dialer_Result.R_NO_TRANSFER_AGENT_AVAILABLE],
  },
  {
    id: Consumer_Dialer_Result.R_ON_BEST_PLAN,
    ...consumerResultMap[Consumer_Dialer_Result.R_ON_BEST_PLAN],
  },
  {
    id: Consumer_Dialer_Result.R_DOES_NOT_MAKE_HEALTHCARE_DECISIONS,
    ...consumerResultMap[
      Consumer_Dialer_Result.R_DOES_NOT_MAKE_HEALTHCARE_DECISIONS
    ],
  },
  {
    id: Consumer_Dialer_Result.R_UHC_CALLBACK,
    ...consumerResultMap[Consumer_Dialer_Result.R_UHC_CALLBACK],
  },
  {
    id: Consumer_Dialer_Result.R_HOME_OFFICE_VISIT,
    ...consumerResultMap[Consumer_Dialer_Result.R_HOME_OFFICE_VISIT],
  },
  {
    id: Consumer_Dialer_Result.R_INTERNAL_TRANSFER,
    ...consumerResultMap[Consumer_Dialer_Result.R_INTERNAL_TRANSFER],
  },
  {
    id: Consumer_Dialer_Result.R_AGENT_TEST_CALL,
    ...consumerResultMap[Consumer_Dialer_Result.R_AGENT_TEST_CALL],
  },
  {
    id: Consumer_Dialer_Result.R_AGENT_HANGUP,
    ...consumerResultMap[Consumer_Dialer_Result.R_AGENT_HANGUP],
  },
  {
    id: Consumer_Dialer_Result.R_NOT_INTERESTED,
    ...consumerResultMap[Consumer_Dialer_Result.R_NOT_INTERESTED],
  },
  {
    id: Consumer_Dialer_Result.R_NO_MEDICARE_CARD_SSN,
    ...consumerResultMap[Consumer_Dialer_Result.R_NO_MEDICARE_CARD_SSN],
  },
  {
    id: Consumer_Dialer_Result.R_TRANSFERRED,
    ...consumerResultMap[Consumer_Dialer_Result.R_TRANSFERRED],
  },
  {
    id: Consumer_Dialer_Result.R_ENROLLER_FAILURE,
    ...consumerResultMap[Consumer_Dialer_Result.R_ENROLLER_FAILURE],
  },
  {
    id: Consumer_Dialer_Result.R_MEMBER_SERVICES_TRANSFER,
    ...consumerResultMap[Consumer_Dialer_Result.R_MEMBER_SERVICES_TRANSFER],
  },
  {
    id: Consumer_Dialer_Result.R_BROKER_TRANSFER,
    ...consumerResultMap[Consumer_Dialer_Result.R_BROKER_TRANSFER],
  },
  {
    id: Consumer_Dialer_Result.R_NON_CONSUMER_CALL,
    ...consumerResultMap[Consumer_Dialer_Result.R_NON_CONSUMER_CALL],
  },
  {
    id: Consumer_Dialer_Result.T_CLIENT_NO_A_B,
    ...consumerResultMap[Consumer_Dialer_Result.T_CLIENT_NO_A_B],
  },
  {
    id: Consumer_Dialer_Result.T_CLIENT_REFUSES_GIVE_INFO,
    ...consumerResultMap[Consumer_Dialer_Result.T_CLIENT_REFUSES_GIVE_INFO],
  },
  {
    id: Consumer_Dialer_Result.T_DO_NOT_CALL,
    ...consumerResultMap[Consumer_Dialer_Result.T_DO_NOT_CALL],
  },
  {
    id: Consumer_Dialer_Result.T_LANGUAGE_BARRIER,
    ...consumerResultMap[Consumer_Dialer_Result.T_LANGUAGE_BARRIER],
  },
  {
    id: Consumer_Dialer_Result.T_MEDICARE_SUPPLEMENT_PLAN,
    ...consumerResultMap[Consumer_Dialer_Result.T_MEDICARE_SUPPLEMENT_PLAN],
  },
  {
    id: Consumer_Dialer_Result.T_RETIREMENT_PLAN,
    ...consumerResultMap[Consumer_Dialer_Result.T_RETIREMENT_PLAN],
  },
  {
    id: Consumer_Dialer_Result.T_EXISTING_CLIENT,
    ...consumerResultMap[Consumer_Dialer_Result.T_EXISTING_CLIENT],
  },
  {
    id: Consumer_Dialer_Result.T_DEAD_AIR,
    ...consumerResultMap[Consumer_Dialer_Result.T_DEAD_AIR],
  },
  {
    id: Consumer_Dialer_Result.T_DECEASED,
    ...consumerResultMap[Consumer_Dialer_Result.T_DECEASED],
  },
  {
    id: Consumer_Dialer_Result.T_PLAN_HOPPER,
    ...consumerResultMap[Consumer_Dialer_Result.T_PLAN_HOPPER],
  },
  {
    id: Consumer_Dialer_Result.T_POA_DEMENTIA,
    ...consumerResultMap[Consumer_Dialer_Result.T_POA_DEMENTIA],
  },
  {
    id: Consumer_Dialer_Result.T_IN_NURSING_HOME,
    ...consumerResultMap[Consumer_Dialer_Result.T_IN_NURSING_HOME],
  },
  {
    id: Consumer_Dialer_Result.T_CLIENT_NOT_SATISFIED,
    ...consumerResultMap[Consumer_Dialer_Result.T_CLIENT_NOT_SATISFIED],
  },
];

export const consumerResultCategoryMap: {
  [key: number]: Partial<IconListItemA>;
} = {
  [Consumer_Dialer_ResultCategory.SUCCESS]: {
    icon: faPhoneArrowUpRight,
    title: 'Success',
    color: 'green',
  },
  [Consumer_Dialer_ResultCategory.RECYCLE]: {
    icon: faRecycle,
    title: 'Recycle',
    color: 'yellow',
  },
  [Consumer_Dialer_ResultCategory.TRASH]: {
    icon: faTrash,
    title: 'Trash',
    color: 'red',
  },
};

export const consumerResultCategoryList = [
  {
    id: Consumer_Dialer_ResultCategory.SUCCESS,
    ...consumerResultCategoryMap[Consumer_Dialer_ResultCategory.SUCCESS],
    reasons: [
      {
        id: Consumer_Dialer_Result.S_AGENT_TO_AGENT,
        ...consumerResultMap[Consumer_Dialer_Result.S_AGENT_TO_AGENT],
      },
      {
        id: Consumer_Dialer_Result.S_APP_SUBMITTED,
        ...consumerResultMap[Consumer_Dialer_Result.S_APP_SUBMITTED],
      },
      {
        id: Consumer_Dialer_Result.S_APP_SUBMITTED_DOUBLE_SALE,
        ...consumerResultMap[
          Consumer_Dialer_Result.S_APP_SUBMITTED_DOUBLE_SALE
        ],
      },
      {
        id: Consumer_Dialer_Result.S_APP_SUBMITTED_P_ANCILLARY,
        ...consumerResultMap[
          Consumer_Dialer_Result.S_APP_SUBMITTED_P_ANCILLARY
        ],
      },
      {
        id: Consumer_Dialer_Result.S_APP_SUBMITTED_P_MS,
        ...consumerResultMap[Consumer_Dialer_Result.S_APP_SUBMITTED_P_MS],
      },
      {
        id: Consumer_Dialer_Result.S_APP_ANCILLARY,
        ...consumerResultMap[Consumer_Dialer_Result.S_APP_ANCILLARY],
      },
      {
        id: Consumer_Dialer_Result.S_APP_MS,
        ...consumerResultMap[Consumer_Dialer_Result.S_APP_MS],
      },
      {
        id: Consumer_Dialer_Result.S_APP_LIFE,
        ...consumerResultMap[Consumer_Dialer_Result.S_APP_LIFE],
      },
      {
        id: Consumer_Dialer_Result.S_APP_PDP,
        ...consumerResultMap[Consumer_Dialer_Result.S_APP_PDP],
      },
      {
        id: Consumer_Dialer_Result.S_APP_HIP,
        ...consumerResultMap[Consumer_Dialer_Result.S_APP_HIP],
      },
      {
        id: Consumer_Dialer_Result.S_APP_MAPD,
        ...consumerResultMap[Consumer_Dialer_Result.S_APP_MAPD],
      },
      {
        id: Consumer_Dialer_Result.S_EXISTING_CLIENT_CALLBACK,
        ...consumerResultMap[Consumer_Dialer_Result.S_EXISTING_CLIENT_CALLBACK],
      },
      {
        id: Consumer_Dialer_Result.S_APPOINTMENT_BOOKED,
        ...consumerResultMap[Consumer_Dialer_Result.S_APPOINTMENT_BOOKED],
      },
      {
        id: Consumer_Dialer_Result.S_ENROLLER_SUCCESS,
        ...consumerResultMap[Consumer_Dialer_Result.S_ENROLLER_SUCCESS],
      },
      {
        id: Consumer_Dialer_Result.S_WELCOME_CALL_SUCCESS,
        ...consumerResultMap[Consumer_Dialer_Result.S_WELCOME_CALL_SUCCESS],
      },
      {
        id: Consumer_Dialer_Result.S_RETENTION_SAVED,
        ...consumerResultMap[Consumer_Dialer_Result.S_RETENTION_SAVED],
      },
      {
        id: Consumer_Dialer_Result.S_FRONTER_SUCCESS,
        ...consumerResultMap[Consumer_Dialer_Result.S_FRONTER_SUCCESS],
      },
      {
        id: Consumer_Dialer_Result.S_APP_ANCILLARY_DOUBLE,
        ...consumerResultMap[Consumer_Dialer_Result.S_APP_ANCILLARY_DOUBLE],
      },
      {
        id: Consumer_Dialer_Result.S_APP_FE_DOUBLE_ANCILLARY,
        ...consumerResultMap[Consumer_Dialer_Result.S_APP_FE_DOUBLE_ANCILLARY],
      },
      {
        id: Consumer_Dialer_Result.S_APP_FE_DOUBLE,
        ...consumerResultMap[Consumer_Dialer_Result.S_APP_FE_DOUBLE],
      },
      {
        id: Consumer_Dialer_Result.S_APP_SUBMITTED_DOUBLE_SALE_ANCILLARY,
        ...consumerResultMap[
          Consumer_Dialer_Result.S_APP_SUBMITTED_DOUBLE_SALE_ANCILLARY
        ],
      },
      {
        id: Consumer_Dialer_Result.S_APP_SUBMITTED_DOUBLE_SALE_ANCILLARY_DOUBLE,
        ...consumerResultMap[
          Consumer_Dialer_Result.S_APP_SUBMITTED_DOUBLE_SALE_ANCILLARY_DOUBLE
        ],
      },
      {
        id: Consumer_Dialer_Result.S_APP_SUBMITTED_TRIPLE_SALE,
        ...consumerResultMap[
          Consumer_Dialer_Result.S_APP_SUBMITTED_TRIPLE_SALE
        ],
      },
    ],
  },
  {
    id: Consumer_Dialer_ResultCategory.RECYCLE,
    ...consumerResultCategoryMap[Consumer_Dialer_ResultCategory.RECYCLE],
    reasons: [
      {
        id: Consumer_Dialer_Result.R_ANSWERING_MACHINE,
        ...consumerResultMap[Consumer_Dialer_Result.R_ANSWERING_MACHINE],
      },
      {
        id: Consumer_Dialer_Result.R_CALL_BACK,
        ...consumerResultMap[Consumer_Dialer_Result.R_CALL_BACK],
      },
      {
        id: Consumer_Dialer_Result.R_CLIENT_HANGUP,
        ...consumerResultMap[Consumer_Dialer_Result.R_CLIENT_HANGUP],
      },
      {
        id: Consumer_Dialer_Result.R_CLIENT_HANGUP_DURING_TRANSFER,
        ...consumerResultMap[
          Consumer_Dialer_Result.R_CLIENT_HANGUP_DURING_TRANSFER
        ],
      },
      {
        id: Consumer_Dialer_Result.R_CLIENT_UNWILLING_SWITCH,
        ...consumerResultMap[Consumer_Dialer_Result.R_CLIENT_UNWILLING_SWITCH],
      },
      {
        id: Consumer_Dialer_Result.R_MISSED_OPPORTUNITY,
        ...consumerResultMap[Consumer_Dialer_Result.R_MISSED_OPPORTUNITY],
      },
      {
        id: Consumer_Dialer_Result.R_NOT_AVAILABLE,
        ...consumerResultMap[Consumer_Dialer_Result.R_NOT_AVAILABLE],
      },
      {
        id: Consumer_Dialer_Result.R_NO_SEP,
        ...consumerResultMap[Consumer_Dialer_Result.R_NO_SEP],
      },
      {
        id: Consumer_Dialer_Result.R_NOT_LICENSED_STATE,
        ...consumerResultMap[Consumer_Dialer_Result.R_NOT_LICENSED_STATE],
      },
      {
        id: Consumer_Dialer_Result.R_NON_QUALIFIED_TRANSFER,
        ...consumerResultMap[Consumer_Dialer_Result.R_NON_QUALIFIED_TRANSFER],
      },
      {
        id: Consumer_Dialer_Result.R_NO_TRANSFER_AGENT_AVAILABLE,
        ...consumerResultMap[
          Consumer_Dialer_Result.R_NO_TRANSFER_AGENT_AVAILABLE
        ],
      },
      {
        id: Consumer_Dialer_Result.R_ON_BEST_PLAN,
        ...consumerResultMap[Consumer_Dialer_Result.R_ON_BEST_PLAN],
      },
      {
        id: Consumer_Dialer_Result.R_DOES_NOT_MAKE_HEALTHCARE_DECISIONS,
        ...consumerResultMap[
          Consumer_Dialer_Result.R_DOES_NOT_MAKE_HEALTHCARE_DECISIONS
        ],
      },
      {
        id: Consumer_Dialer_Result.R_UHC_CALLBACK,
        ...consumerResultMap[Consumer_Dialer_Result.R_UHC_CALLBACK],
      },
      {
        id: Consumer_Dialer_Result.R_HOME_OFFICE_VISIT,
        ...consumerResultMap[Consumer_Dialer_Result.R_HOME_OFFICE_VISIT],
      },
      {
        id: Consumer_Dialer_Result.R_INTERNAL_TRANSFER,
        ...consumerResultMap[Consumer_Dialer_Result.R_INTERNAL_TRANSFER],
      },
      {
        id: Consumer_Dialer_Result.R_AGENT_TEST_CALL,
        ...consumerResultMap[Consumer_Dialer_Result.R_AGENT_TEST_CALL],
      },
      {
        id: Consumer_Dialer_Result.R_AGENT_HANGUP,
        ...consumerResultMap[Consumer_Dialer_Result.R_AGENT_HANGUP],
      },
      {
        id: Consumer_Dialer_Result.R_NOT_INTERESTED,
        ...consumerResultMap[Consumer_Dialer_Result.R_NOT_INTERESTED],
      },
      {
        id: Consumer_Dialer_Result.R_NO_MEDICARE_CARD_SSN,
        ...consumerResultMap[Consumer_Dialer_Result.R_NO_MEDICARE_CARD_SSN],
      },
      {
        id: Consumer_Dialer_Result.R_TRANSFERRED,
        ...consumerResultMap[Consumer_Dialer_Result.R_TRANSFERRED],
      },
      {
        id: Consumer_Dialer_Result.R_CALL_QUALITY,
        ...consumerResultMap[Consumer_Dialer_Result.R_CALL_QUALITY],
      },
      {
        id: Consumer_Dialer_Result.R_LIS_PENDING,
        ...consumerResultMap[Consumer_Dialer_Result.R_LIS_PENDING],
      },
      {
        id: Consumer_Dialer_Result.R_MEDICAID_PENDING,
        ...consumerResultMap[Consumer_Dialer_Result.R_MEDICAID_PENDING],
      },
      {
        id: Consumer_Dialer_Result.R_MEDICARE_QUALIFICATIONS,
        ...consumerResultMap[Consumer_Dialer_Result.R_MEDICARE_QUALIFICATIONS],
      },
      {
        id: Consumer_Dialer_Result.R_NO_MEDICARE,
        ...consumerResultMap[Consumer_Dialer_Result.R_NO_MEDICARE],
      },
      {
        id: Consumer_Dialer_Result.R_NOT_DECISION_MAKER,
        ...consumerResultMap[Consumer_Dialer_Result.R_NOT_DECISION_MAKER],
      },
      {
        id: Consumer_Dialer_Result.R_NOT_MENTALLY_CAPABLE,
        ...consumerResultMap[Consumer_Dialer_Result.R_NOT_MENTALLY_CAPABLE],
      },
      {
        id: Consumer_Dialer_Result.R_SUSPICIOUS_AD,
        ...consumerResultMap[Consumer_Dialer_Result.R_SUSPICIOUS_AD],
      },
      {
        id: Consumer_Dialer_Result.R_SYSTEM_ACCESS,
        ...consumerResultMap[Consumer_Dialer_Result.R_SYSTEM_ACCESS],
      },
      {
        id: Consumer_Dialer_Result.R_UNCLEAR_DISCONNECT,
        ...consumerResultMap[Consumer_Dialer_Result.R_UNCLEAR_DISCONNECT],
      },
      {
        id: Consumer_Dialer_Result.R_ENROLLER_FAILURE,
        ...consumerResultMap[Consumer_Dialer_Result.R_ENROLLER_FAILURE],
      },
      {
        id: Consumer_Dialer_Result.R_MEMBER_SERVICES_TRANSFER,
        ...consumerResultMap[Consumer_Dialer_Result.R_MEMBER_SERVICES_TRANSFER],
      },
      {
        id: Consumer_Dialer_Result.R_BROKER_TRANSFER,
        ...consumerResultMap[Consumer_Dialer_Result.R_BROKER_TRANSFER],
      },
      {
        id: Consumer_Dialer_Result.R_NON_CONSUMER_CALL,
        ...consumerResultMap[Consumer_Dialer_Result.R_NON_CONSUMER_CALL],
      },
    ],
  },
  {
    id: Consumer_Dialer_ResultCategory.TRASH,
    ...consumerResultCategoryMap[Consumer_Dialer_ResultCategory.TRASH],
    reasons: [
      {
        id: Consumer_Dialer_Result.T_DO_NOT_CALL,
        ...consumerResultMap[Consumer_Dialer_Result.T_DO_NOT_CALL],
      },
      {
        id: Consumer_Dialer_Result.T_EXISTING_CLIENT,
        ...consumerResultMap[Consumer_Dialer_Result.T_EXISTING_CLIENT],
      },
      {
        id: Consumer_Dialer_Result.T_MEDICARE_SUPPLEMENT_PLAN,
        ...consumerResultMap[Consumer_Dialer_Result.T_MEDICARE_SUPPLEMENT_PLAN],
      },
      {
        id: Consumer_Dialer_Result.T_CLIENT_NO_A_B,
        ...consumerResultMap[Consumer_Dialer_Result.T_CLIENT_NO_A_B],
      },
      {
        id: Consumer_Dialer_Result.T_NOT_INTERESTED,
        ...consumerResultMap[Consumer_Dialer_Result.T_NOT_INTERESTED],
      },
      {
        id: Consumer_Dialer_Result.T_RETIREMENT_PLAN,
        ...consumerResultMap[Consumer_Dialer_Result.T_RETIREMENT_PLAN],
      },
      {
        id: Consumer_Dialer_Result.T_UNDER_65,
        ...consumerResultMap[Consumer_Dialer_Result.T_UNDER_65],
      },
      {
        id: Consumer_Dialer_Result.T_WRONG_NUMBER,
        ...consumerResultMap[Consumer_Dialer_Result.T_WRONG_NUMBER],
      },
      {
        id: Consumer_Dialer_Result.T_CLIENT_REFUSES_GIVE_INFO,
        ...consumerResultMap[Consumer_Dialer_Result.T_CLIENT_REFUSES_GIVE_INFO],
      },
      {
        id: Consumer_Dialer_Result.T_LANGUAGE_BARRIER,
        ...consumerResultMap[Consumer_Dialer_Result.T_LANGUAGE_BARRIER],
      },
      {
        id: Consumer_Dialer_Result.T_DEAD_AIR,
        ...consumerResultMap[Consumer_Dialer_Result.T_DEAD_AIR],
      },
      {
        id: Consumer_Dialer_Result.T_DECEASED,
        ...consumerResultMap[Consumer_Dialer_Result.T_DECEASED],
      },
      {
        id: Consumer_Dialer_Result.T_PLAN_HOPPER,
        ...consumerResultMap[Consumer_Dialer_Result.T_PLAN_HOPPER],
      },
      {
        id: Consumer_Dialer_Result.T_POA_DEMENTIA,
        ...consumerResultMap[Consumer_Dialer_Result.T_POA_DEMENTIA],
      },
      {
        id: Consumer_Dialer_Result.T_IN_NURSING_HOME,
        ...consumerResultMap[Consumer_Dialer_Result.T_IN_NURSING_HOME],
      },
      {
        id: Consumer_Dialer_Result.T_CLIENT_NOT_SATISFIED,
        ...consumerResultMap[Consumer_Dialer_Result.T_CLIENT_NOT_SATISFIED],
      },
    ],
  },
];

export const dialerResultCategoryList = [
  {
    id: consumer_Dialer_ResultCategoryToJSON(
      Consumer_Dialer_ResultCategory.SUCCESS
    ),
    ...consumerResultCategoryMap[Consumer_Dialer_ResultCategory.SUCCESS],
    reasons: [
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.S_AGENT_TO_AGENT
        ),
        ...consumerResultMap[Consumer_Dialer_Result.S_AGENT_TO_AGENT],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.S_APP_SUBMITTED
        ),
        ...consumerResultMap[Consumer_Dialer_Result.S_APP_SUBMITTED],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.S_APP_SUBMITTED_DOUBLE_SALE
        ),
        ...consumerResultMap[
          Consumer_Dialer_Result.S_APP_SUBMITTED_DOUBLE_SALE
        ],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.S_APP_SUBMITTED_P_ANCILLARY
        ),
        ...consumerResultMap[
          Consumer_Dialer_Result.S_APP_SUBMITTED_P_ANCILLARY
        ],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.S_APP_SUBMITTED_P_MS
        ),
        ...consumerResultMap[Consumer_Dialer_Result.S_APP_SUBMITTED_P_MS],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.S_APP_ANCILLARY
        ),
        ...consumerResultMap[Consumer_Dialer_Result.S_APP_ANCILLARY],
      },
      {
        id: consumer_Dialer_ResultToJSON(Consumer_Dialer_Result.S_APP_MS),
        ...consumerResultMap[Consumer_Dialer_Result.S_APP_MS],
      },
      {
        id: consumer_Dialer_ResultToJSON(Consumer_Dialer_Result.S_APP_LIFE),
        ...consumerResultMap[Consumer_Dialer_Result.S_APP_LIFE],
      },
      {
        id: consumer_Dialer_ResultToJSON(Consumer_Dialer_Result.S_APP_PDP),
        ...consumerResultMap[Consumer_Dialer_Result.S_APP_PDP],
      },
      {
        id: consumer_Dialer_ResultToJSON(Consumer_Dialer_Result.S_APP_HIP),
        ...consumerResultMap[Consumer_Dialer_Result.S_APP_HIP],
      },
      {
        id: consumer_Dialer_ResultToJSON(Consumer_Dialer_Result.S_APP_MAPD),
        ...consumerResultMap[Consumer_Dialer_Result.S_APP_MAPD],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.S_EXISTING_CLIENT_CALLBACK
        ),
        ...consumerResultMap[Consumer_Dialer_Result.S_EXISTING_CLIENT_CALLBACK],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.S_APPOINTMENT_BOOKED
        ),
        ...consumerResultMap[Consumer_Dialer_Result.S_APPOINTMENT_BOOKED],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.S_ENROLLER_SUCCESS
        ),
        ...consumerResultMap[Consumer_Dialer_Result.S_ENROLLER_SUCCESS],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.S_WELCOME_CALL_SUCCESS
        ),
        ...consumerResultMap[Consumer_Dialer_Result.S_WELCOME_CALL_SUCCESS],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.S_RETENTION_SAVED
        ),
        ...consumerResultMap[Consumer_Dialer_Result.S_RETENTION_SAVED],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.S_FRONTER_SUCCESS
        ),
        ...consumerResultMap[Consumer_Dialer_Result.S_FRONTER_SUCCESS],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.S_APP_ANCILLARY_DOUBLE
        ),
        ...consumerResultMap[Consumer_Dialer_Result.S_APP_ANCILLARY_DOUBLE],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.S_APP_FE_DOUBLE_ANCILLARY
        ),
        ...consumerResultMap[Consumer_Dialer_Result.S_APP_FE_DOUBLE_ANCILLARY],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.S_APP_FE_DOUBLE
        ),
        ...consumerResultMap[Consumer_Dialer_Result.S_APP_FE_DOUBLE],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.S_APP_SUBMITTED_DOUBLE_SALE_ANCILLARY
        ),
        ...consumerResultMap[
          Consumer_Dialer_Result.S_APP_SUBMITTED_DOUBLE_SALE_ANCILLARY
        ],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.S_APP_SUBMITTED_DOUBLE_SALE_ANCILLARY_DOUBLE
        ),
        ...consumerResultMap[
          Consumer_Dialer_Result.S_APP_SUBMITTED_DOUBLE_SALE_ANCILLARY_DOUBLE
        ],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.S_APP_SUBMITTED_TRIPLE_SALE
        ),
        ...consumerResultMap[
          Consumer_Dialer_Result.S_APP_SUBMITTED_TRIPLE_SALE
        ],
      },
    ],
  },
  {
    id: consumer_Dialer_ResultCategoryToJSON(
      Consumer_Dialer_ResultCategory.RECYCLE
    ),
    ...consumerResultCategoryMap[Consumer_Dialer_ResultCategory.RECYCLE],
    reasons: [
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.R_ANSWERING_MACHINE
        ),
        ...consumerResultMap[Consumer_Dialer_Result.R_ANSWERING_MACHINE],
      },
      {
        id: consumer_Dialer_ResultToJSON(Consumer_Dialer_Result.R_CALL_BACK),
        ...consumerResultMap[Consumer_Dialer_Result.R_CALL_BACK],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.R_CLIENT_HANGUP
        ),
        ...consumerResultMap[Consumer_Dialer_Result.R_CLIENT_HANGUP],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.R_CLIENT_HANGUP_DURING_TRANSFER
        ),
        ...consumerResultMap[
          Consumer_Dialer_Result.R_CLIENT_HANGUP_DURING_TRANSFER
        ],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.R_CLIENT_UNWILLING_SWITCH
        ),
        ...consumerResultMap[Consumer_Dialer_Result.R_CLIENT_UNWILLING_SWITCH],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.R_MISSED_OPPORTUNITY
        ),
        ...consumerResultMap[Consumer_Dialer_Result.R_MISSED_OPPORTUNITY],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.R_NOT_AVAILABLE
        ),
        ...consumerResultMap[Consumer_Dialer_Result.R_NOT_AVAILABLE],
      },
      {
        id: consumer_Dialer_ResultToJSON(Consumer_Dialer_Result.R_NO_SEP),
        ...consumerResultMap[Consumer_Dialer_Result.R_NO_SEP],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.R_NOT_LICENSED_STATE
        ),
        ...consumerResultMap[Consumer_Dialer_Result.R_NOT_LICENSED_STATE],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.R_NON_QUALIFIED_TRANSFER
        ),
        ...consumerResultMap[Consumer_Dialer_Result.R_NON_QUALIFIED_TRANSFER],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.R_NO_TRANSFER_AGENT_AVAILABLE
        ),
        ...consumerResultMap[
          Consumer_Dialer_Result.R_NO_TRANSFER_AGENT_AVAILABLE
        ],
      },
      {
        id: consumer_Dialer_ResultToJSON(Consumer_Dialer_Result.R_ON_BEST_PLAN),
        ...consumerResultMap[Consumer_Dialer_Result.R_ON_BEST_PLAN],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.R_DOES_NOT_MAKE_HEALTHCARE_DECISIONS
        ),
        ...consumerResultMap[
          Consumer_Dialer_Result.R_DOES_NOT_MAKE_HEALTHCARE_DECISIONS
        ],
      },
      {
        id: consumer_Dialer_ResultToJSON(Consumer_Dialer_Result.R_UHC_CALLBACK),
        ...consumerResultMap[Consumer_Dialer_Result.R_UHC_CALLBACK],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.R_HOME_OFFICE_VISIT
        ),
        ...consumerResultMap[Consumer_Dialer_Result.R_HOME_OFFICE_VISIT],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.R_INTERNAL_TRANSFER
        ),
        ...consumerResultMap[Consumer_Dialer_Result.R_INTERNAL_TRANSFER],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.R_AGENT_TEST_CALL
        ),
        ...consumerResultMap[Consumer_Dialer_Result.R_AGENT_TEST_CALL],
      },
      {
        id: consumer_Dialer_ResultToJSON(Consumer_Dialer_Result.R_AGENT_HANGUP),
        ...consumerResultMap[Consumer_Dialer_Result.R_AGENT_HANGUP],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.R_NOT_INTERESTED
        ),
        ...consumerResultMap[Consumer_Dialer_Result.R_NOT_INTERESTED],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.R_NO_MEDICARE_CARD_SSN
        ),
        ...consumerResultMap[Consumer_Dialer_Result.R_NO_MEDICARE_CARD_SSN],
      },
      {
        id: consumer_Dialer_ResultToJSON(Consumer_Dialer_Result.R_TRANSFERRED),
        ...consumerResultMap[Consumer_Dialer_Result.R_TRANSFERRED],
      },
      {
        id: consumer_Dialer_ResultToJSON(Consumer_Dialer_Result.R_CALL_QUALITY),
        ...consumerResultMap[Consumer_Dialer_Result.R_CALL_QUALITY],
      },
      {
        id: consumer_Dialer_ResultToJSON(Consumer_Dialer_Result.R_LIS_PENDING),
        ...consumerResultMap[Consumer_Dialer_Result.R_LIS_PENDING],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.R_MEDICAID_PENDING
        ),
        ...consumerResultMap[Consumer_Dialer_Result.R_MEDICAID_PENDING],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.R_MEDICARE_QUALIFICATIONS
        ),
        ...consumerResultMap[Consumer_Dialer_Result.R_MEDICARE_QUALIFICATIONS],
      },
      {
        id: consumer_Dialer_ResultToJSON(Consumer_Dialer_Result.R_NO_MEDICARE),
        ...consumerResultMap[Consumer_Dialer_Result.R_NO_MEDICARE],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.R_NOT_DECISION_MAKER
        ),
        ...consumerResultMap[Consumer_Dialer_Result.R_NOT_DECISION_MAKER],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.R_NOT_MENTALLY_CAPABLE
        ),
        ...consumerResultMap[Consumer_Dialer_Result.R_NOT_MENTALLY_CAPABLE],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.R_SUSPICIOUS_AD
        ),
        ...consumerResultMap[Consumer_Dialer_Result.R_SUSPICIOUS_AD],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.R_SYSTEM_ACCESS
        ),
        ...consumerResultMap[Consumer_Dialer_Result.R_SYSTEM_ACCESS],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.R_UNCLEAR_DISCONNECT
        ),
        ...consumerResultMap[Consumer_Dialer_Result.R_UNCLEAR_DISCONNECT],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.R_ENROLLER_FAILURE
        ),
        ...consumerResultMap[Consumer_Dialer_Result.R_ENROLLER_FAILURE],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.R_MEMBER_SERVICES_TRANSFER
        ),
        ...consumerResultMap[Consumer_Dialer_Result.R_MEMBER_SERVICES_TRANSFER],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.R_BROKER_TRANSFER
        ),
        ...consumerResultMap[Consumer_Dialer_Result.R_BROKER_TRANSFER],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.R_NON_CONSUMER_CALL
        ),
        ...consumerResultMap[Consumer_Dialer_Result.R_NON_CONSUMER_CALL],
      },
    ],
  },
  {
    id: consumer_Dialer_ResultCategoryToJSON(
      Consumer_Dialer_ResultCategory.TRASH
    ),
    ...consumerResultCategoryMap[Consumer_Dialer_ResultCategory.TRASH],
    reasons: [
      {
        id: consumer_Dialer_ResultToJSON(Consumer_Dialer_Result.T_DO_NOT_CALL),
        ...consumerResultMap[Consumer_Dialer_Result.T_DO_NOT_CALL],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.T_EXISTING_CLIENT
        ),
        ...consumerResultMap[Consumer_Dialer_Result.T_EXISTING_CLIENT],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.T_MEDICARE_SUPPLEMENT_PLAN
        ),
        ...consumerResultMap[Consumer_Dialer_Result.T_MEDICARE_SUPPLEMENT_PLAN],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.T_CLIENT_NO_A_B
        ),
        ...consumerResultMap[Consumer_Dialer_Result.T_CLIENT_NO_A_B],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.T_NOT_INTERESTED
        ),
        ...consumerResultMap[Consumer_Dialer_Result.T_NOT_INTERESTED],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.T_RETIREMENT_PLAN
        ),
        ...consumerResultMap[Consumer_Dialer_Result.T_RETIREMENT_PLAN],
      },
      {
        id: consumer_Dialer_ResultToJSON(Consumer_Dialer_Result.T_UNDER_65),
        ...consumerResultMap[Consumer_Dialer_Result.T_UNDER_65],
      },
      {
        id: consumer_Dialer_ResultToJSON(Consumer_Dialer_Result.T_WRONG_NUMBER),
        ...consumerResultMap[Consumer_Dialer_Result.T_WRONG_NUMBER],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.T_CLIENT_REFUSES_GIVE_INFO
        ),
        ...consumerResultMap[Consumer_Dialer_Result.T_CLIENT_REFUSES_GIVE_INFO],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.T_LANGUAGE_BARRIER
        ),
        ...consumerResultMap[Consumer_Dialer_Result.T_LANGUAGE_BARRIER],
      },
      {
        id: consumer_Dialer_ResultToJSON(Consumer_Dialer_Result.T_DEAD_AIR),
        ...consumerResultMap[Consumer_Dialer_Result.T_DEAD_AIR],
      },
      {
        id: consumer_Dialer_ResultToJSON(Consumer_Dialer_Result.T_DECEASED),
        ...consumerResultMap[Consumer_Dialer_Result.T_DECEASED],
      },
      {
        id: consumer_Dialer_ResultToJSON(Consumer_Dialer_Result.T_PLAN_HOPPER),
        ...consumerResultMap[Consumer_Dialer_Result.T_PLAN_HOPPER],
      },
      {
        id: consumer_Dialer_ResultToJSON(Consumer_Dialer_Result.T_POA_DEMENTIA),
        ...consumerResultMap[Consumer_Dialer_Result.T_POA_DEMENTIA],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.T_IN_NURSING_HOME
        ),
        ...consumerResultMap[Consumer_Dialer_Result.T_IN_NURSING_HOME],
      },
      {
        id: consumer_Dialer_ResultToJSON(
          Consumer_Dialer_Result.T_CLIENT_NOT_SATISFIED
        ),
        ...consumerResultMap[Consumer_Dialer_Result.T_CLIENT_NOT_SATISFIED],
      },
    ],
  },
];
